import React, { useState } from "react";

// import Draggable from "react-draggable";
// import cx from "classnames";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { IconButton, Slide } from '@mui/material';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import { getImage } from "../../../service/api.service";
import { PrettoSlider } from "../../common/codeHelper";
import { EventEmitter } from "../../../event";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import ZoomOutIcon from '@mui/icons-material/ZoomOut';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import CancelIcon from '@mui/icons-material/Cancel';
// import PinchZoomPan from "react-responsive-pinch-zoom-pan";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
// import "./styles.css";
const styles = {
  fullScreenButton: {
    padding: "3px 0px 0px 14px",
  },
  imagesBox: {
    border: " 1px solid #b8bbc2",
    width: "100%",
    overflow: "hidden"
  },
  imgBox: {
    width: "100%"
  }
}
function DcmDialogWOCornerstone(props) {
  let minScale = 1, maxScale = 10;// zoomStep = 0.5, minScale = 1, maxScale = 10, defaultScale = 1, defaultRotate = 0;

  const [openDcmDialog, setOpenDcmDialog] = React.useState(false);
  const [image, setImage] = useState();
  const [zoomValue, setZoomValue] = useState(1);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("I'm a custom snackbar");
  const [severity, setSeverity] = useState(
    "success"
  ); /* error | warning | info */

  const showMessage = (message, severity = "info", duration = 4000) => {
    setMessage(message);
    setSeverity(severity);
    // setDuration(duration);
    setOpen(true);
  };

  const handleClosesnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };
  // const isDraggable = scale > 1;
  const state = {
    imageId: '',
    image: '',
  };
  // const zoomIn = () => {
  //   const newScale = scale + zoomStep;
  //   setScale(newScale <= maxScale ? newScale : maxScale);
  // };

  const handleClickOpen = () => {
    loadImage(props.image);
    setOpenDcmDialog(true);
  };
  React.useEffect(() => {

  })
  const loadImage = (id) => {
    if (props.image && state.imageId !== props.image) {
      state.imageId = props.image;
      getImage(props.image, (resp) => {

        setImage('data: image / png; base64,' + resp.fileData)
      });
    }
  }

  const handleClose = () => {

    setOpenDcmDialog(false);
    EventEmitter.dispatch("zoominpopupclose", true);
  }; 

  const updatezoomValue = (scaleip, type) => {
    setZoomValue(Number(scaleip).toFixed(2))


  };

  const resetZoomvalue = () => {
    setZoomValue(1);
    showMessage(`Analysis slice reset to initial View`);
  }



  function numFormatter(value) {
    const per = (Number(value) * 10).toFixed(1);
     return per + '%';
  }


  return (
    <div className=" animate__animated animate__fadeIn" >
      <div variant="outlined" onClick={handleClickOpen}>
        <IconButton
          color="inherit"
          aria-label="New Screen"
          edge="start"
          style={styles.fullScreenButton}
        >
          <FullscreenIcon />
        </IconButton>
      </div>
      <Dialog
        open={openDcmDialog}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        fullWidth
        // maxWidth='lg'
        aria-describedby="alert-dialog-slide-description"
        className=" animate__animated animate__fadeIn"
      >
        <DialogTitle sx={{ textAlign: 'center' }}>
          {props.extraData?.heading} {
            props.extraData?.key &&
            <div className="text-sm text-clip animate__animated animate__fadeIn">
              <b> {props.extraData?.key.map(
                (name, index) => {
                  return <span key={index}>{name}</span>
                })
              }</b>
              {props.extraData?.value ? <span> Value: <b>{props.extraData?.value} </b></span> : ''}
            </div>}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <div className="justify-self-center items-center flex flex-col" >
              <TransformWrapper
                initialScale={1}
                initialPositionX={0}
                maxScale={10}
                initialPositionY={0}
              >
                {({ zoomIn, zoomOut, setTransform, centerView, resetTransform, ...rest }) => (
                  <React.Fragment>
                    <div
                      className="viewportElementDcm"
                      style={{
                        // height: '450px',
                        // height: props.extraData?.height ? (props.extraData?.height > dialogOuter?.offsetHeight-60 ? calculateDimension('height', props.extraData?.height, dialogOuter?.offsetHeight-60) : props.extraData?.height + 'px') : '450px',
                        // width: props.extraData?.width ? (props.extraData?.width > dialogOuter?.offsetWidth-60 ? calculateDimension('width', props.extraData?.width, dialogOuter?.offsetWidth-60) : props.extraData?.width + 'px') : '512px',
                        maxWidth: "100%",
                        maxHeight: "100%",
                        position: "relative",
                        color: "white"
                      }}
                    >


                      <TransformComponent>
                        <img
                          style={{
                            // width: "100%",
                            height: '100%',
                            maxHeight: '430px',

                          }}
                          src={image}
                          alt="thumbnail"

                        />
                      </TransformComponent>

                    </div>
                    <div className='text-sm'>
                      Instruction:
                      Click and drag on the image, at the location that you want to zoom.
                    </div>
                    <div className=" w-full ">
                      <div className="">
                        <PrettoSlider
                          valueLabelDisplay="auto"
                          aria-label="pretto slider"
                          defaultValue={1}
                          step={0.01}
                          marks
                          min={minScale}
                          max={maxScale}
                          value={zoomValue}
                          valueLabelFormat={value => <div>{numFormatter(value)}</div>}
                          onChange={(e) => {

                            // const diff = Number((e.target.value - zoomValue).toFixed(2));
                             // if (diff > 0) {
                            // zoomIn(Math.abs(diff), 300, 'easeOut');
                            centerView(e.target.value, 300, 'easeOut')
                            // setTransform(0, 0, e.target.value, 300, 'easeOut')
                            updatezoomValue((e.target.value), 'in')
                            // } else {
                            //   zoomOut(Math.abs(diff), 300, 'easeOut');
                            //   updatezoomValue(Math.abs(diff), 'out')
                            // }
                          }}

                        />

                      </div>
                    </div>



                    <div className="flex flex-row w-full mt-2 justify-center relative animate__animated animate__fadeIn subicon">
                      <div className="cursor-pointer" onClick={() => { 
                        centerView(Number(zoomValue) + 1, 300, 'easeOut');
                        updatezoomValue((Number(zoomValue) +1), 'in');
                      }}
                      >
                        <ZoomInIcon color="primary" className="mx-4" />
                      </div>
                      <div className="cursor-pointer" onClick={() => {
                        // zoomOut(0.01, 300, 'easeOut'); updatezoomValue(0.01, 'out')
                        centerView(Number(zoomValue) - 1, 300, 'easeOut')
                        updatezoomValue((Number(zoomValue) - 1), 'out')
                      }}
                      >
                        <ZoomOutIcon color="primary" className="mx-4" />
                      </div>
                      <div className="cursor-pointer" onClick={() => { resetTransform(300, 'easeOut'); resetZoomvalue() }} >
                        <RestartAltIcon color="primary" className="mx-4" /></div>
                      <div className="cursor-pointer" onClick={handleClose}><CancelIcon color="primary" className="mx-4" />
                      </div>
                      {/* <button onClick={() => { zoomIn(0.01, 300, 'easeOut'); updatezoomValue(0.01, 'in') }} className="border border-[#b8bbc2] bg-[#002E98] mb-2 mx-2 text-white text-center px-3 py-2  rounded-md shadow-md  cursor-pointer">Zoom  +</button>
                      <button onClick={() => { zoomOut(0.01, 300, 'easeOut'); updatezoomValue(0.01, 'out') }} className="border border-[#b8bbc2] bg-[#002E98] mb-2 mx-2 text-white text-center px-3 py-2  rounded-md shadow-md cursor-pointer">Zoom -</button>
                      <div onClick={() => { resetTransform(300, 'easeOut'); resetZoomvalue() }} className="border border-[#b8bbc2] bg-[#002E98] mb-2 mx-2 text-white text-center px-3 py-2  rounded-md shadow-md  cursor-pointer">Reset</div>
                      <div onClick={handleClose} className="border border-[#b8bbc2] bg-[#002E98] mb-2  mx-2 text-white text-center px-3 py-2  rounded-md shadow-md cursor-pointer">Close</div> */}
                     
                    </div>
                  </React.Fragment>
                )}
              </TransformWrapper>


            </div>
            <>
              <Snackbar
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "center"
                }}
                autoHideDuration={4000}
                open={open}
                onClose={handleClosesnackbar}
              >
                <Alert onClose={handleClose} severity={severity} sx={{ width: '100%' }}>
                  {message}
                </Alert>
              </Snackbar>
            </>

          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ textAlign: "center", flexbox: "flex", justifyContent: "center" }}>
        </DialogActions>
      </Dialog>
    </div>

  );
}

export default DcmDialogWOCornerstone; 
